import { array, object, string } from 'prop-types'
import React from 'react'

import { isEmpty, nonNull } from '../../../external/utilities/GeneralUtils'
import Translation from '../../Translation'
import HackHTag from '../../shared/text/HackHTag'

/* Internal */
const FacilityContactInfo = ({
  intl,
  contactAddress,
  contactPhone,
  contractCode = null,
}) => {
  const keyQualifier = []
  if (!isEmpty(contractCode)) {
    keyQualifier.push(contractCode)
  }

  function addressComponent(cmp) {
    if (!isEmpty(cmp)) {
      return <p>{cmp}</p>
    }

    return null
  }

  function publicPhone() {
    if (isEmpty(contactPhone)) {
      return null
    }

    let phoneNumbers = ''
    let first = true

    for (const dex in contactPhone) {
      const phone = contactPhone[dex]
      if (phone.phone.type === 'PUBLIC_PHONE') {
        phoneNumbers += (first ? '' : ', ') + phone.phone.number
        first = false
      }
    }

    if (isEmpty(phoneNumbers)) {
      return null
    }

    return (
      <div>
        <HackHTag h3>
          <Translation
            intl={intl}
            messageKey={'labels_facility_overview_phone'}
            keyQualifiers={keyQualifier}
          />
        </HackHTag>
        <p>
          <Translation
            intl={intl}
            messageKey={'labels_facility_overview_phone_information'}
          />{' '}
          : {phoneNumbers}{' '}
        </p>
      </div>
    )
  }

  /* the address data repeats the state province postal code part */
  const concatenatedAddress = `${contactAddress.address.city} ${contactAddress.address.stateProvinceCode} ${contactAddress.address.cityStateZip}`
  let addressLineTwoContent = contactAddress.address.addrLine2
  if (addressLineTwoContent && addressLineTwoContent === concatenatedAddress) {
    addressLineTwoContent = null
  }

  return (
    <div>
      <HackHTag h3>
        <Translation
          intl={intl}
          messageKey={'labels_facility_overview_mailing'}
          keyQualifiers={keyQualifier}
        />
      </HackHTag>
      {addressComponent(nonNull(contactAddress.contactName))}
      {addressComponent(nonNull(contactAddress.address.addrLine1))}
      {addressComponent(nonNull(addressLineTwoContent))}
      {addressComponent(
        `${nonNull(contactAddress.address.city)} ${nonNull(
          contactAddress.address.stateProvinceCode,
        )} ${nonNull(contactAddress.address.cityStateZip)}`,
      )}
      {publicPhone(contactPhone)}
    </div>
  )
}

FacilityContactInfo.propTypes = {
  intl: object.isRequired,
  contactAddress: object.isRequired,
  contactPhone: array,
  contractCode: string,
}

export default FacilityContactInfo
